import React from 'react';
//
import Button from 'antd/lib/button';
import Col from 'antd/lib/col';
import Row from 'antd/lib/row';
import Modal from 'antd/lib/modal';
// APOLLO
import { compose, graphql } from 'react-apollo';
import clientByIdQuery from 'ApolloClient/Queries/clientById';
import sendContractToClient from 'ApolloClient/Mutations/sendContractToClient';
//
import TextInput from 'components/inputs/TextInput';
import TextAreaInput from 'components/inputs/TextAreaInput';
import ChooseEmailTemplateButton from 'components/common/ChooseEmailTemplateButton';
import message from 'antd/lib/message';
import Alert from 'antd/lib/alert';


class SendContractModal extends React.Component {
  state = {
    loading: false,
    errorMessage: null,
  };

  onTemplateSelected = val => {
    this.props.onChange({
      clientEmailMessage: val.body,
      clientEmailSubject: val.subject,
    });
  };

  onSend = async () => {
    const { contract, onEmailSent } = this.props;
    this.setState({ loading: true, errorMessage: null });

    if (!contract.clientEmailSubject) {
      let messageText = 'A subject is required!';
      this.setState({ loading: false, errorMessage: messageText });
      return message.error(message);
    }

    if (!contract.clientEmailMessage) {
      let messageText = 'A message is required!';
      this.setState({ loading: false, errorMessage: messageText });
      return message.error(messageText);
    }

    let variables = {
      _id: contract._id,
      params: {
        clientEmail: contract.clientEmail,
        clientEmailSubject: contract.clientEmailSubject,
        clientEmailMessage: contract.clientEmailMessage,
      },
    };

    let refetchQueries = [
      {
        query: clientByIdQuery,
        variables: { _id: contract.clientId },
      },
    ];

    try {
      await this.props.sendContractToClient({ variables, refetchQueries });
    } catch (err) {
      return err;
    }

    onEmailSent();
  };

  renderBottomRow = () => (
    <Row type="flex" align="middle" justify="center" style={{ height: 75 }}>
      <Col xs={0} sm={14} />
      <Col xs={24} sm={10}>
        <Button type="primary" size="large" loading={this.state.loading} style={s.button} onClick={this.onSend}>
          {!this.state.loading ? 'SEND CONTRACT' : 'SENDING...'}
        </Button>
      </Col>
    </Row>
  );

  render() {
    const {
      sendModalVisible,
      clientSigned,
      contractorSigned,
      currentUserIsContractor,
      toggleSendModal,
    } = this.props;

    // if the contractor has signed, and the current view IS THE CONTRACTOR, then show this text
    if (clientSigned && contractorSigned) {
      return <div />;
    }

    // if the contractor has signed, and the current view IS THE CONTRACTOR, then show this text
    if (contractorSigned && currentUserIsContractor) {
      return (
        <div>
          <Modal
            footer={null}
            title="Send Contract"
            visible={sendModalVisible}
            width={650}
            onCancel={() => toggleSendModal()}
          >
            <div style={{ margin: 'auto', maxWidth: '100%', width: 500 }}>
              <ChooseEmailTemplateButton onTemplateSelected={this.onTemplateSelected} />
              <Row type="flex" align="middle" justify="center" style={{ height: 270, textAlign: 'left' }}>
                <TextInput
                  size="large"
                  onChange={clientEmail => this.props.onChange({ clientEmail })}
                  value={this.props.contract && this.props.contract.clientEmail}
                />
                <TextInput
                  size="large"
                  placeholder="subject"
                  style={{ width: '100%' }}
                  onChange={clientEmailSubject => this.props.onChange({ clientEmailSubject })}
                  value={this.props.contract && this.props.contract.clientEmailSubject}
                />
                <TextAreaInput
                  size="large"
                  style={{ maxWidth: '100%' }}
                  value={this.props.contract && this.props.contract.clientEmailMessage}
                  placeholder={
                    "Thank you for choosing me as your photographer! I can't wait for your session. Please review and sign our contract."
                  }
                  rows={6}
                  onChange={e => {
                    this.props.onChange({
                      clientEmailMessage: e.target.value,
                    });
                  }}
                />
              </Row>
              {this.state.errorMessage && <Alert showIcon type="error" message={this.state.errorMessage} />}
              {this.renderBottomRow()}
            </div>
          </Modal>
        </div>
      );
    }

    return null;
  }
}

const s = {
  button: {
    letterSpacing: '.065em',
    padding: '11px 22px 8px',
    alignSelf: 'center',
    display: 'block',
    minWidth: 200,
    height: 45,
    fontSize: 16,
    maxWidth: '100%',
  },
};

export default compose(graphql(sendContractToClient, { name: 'sendContractToClient' }))(SendContractModal);



// WEBPACK FOOTER //
// ./src/routes/contract-view/SignedPDF/SendContractModal/index.js